module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAAXNSR0IArs4c6QAAAHJJREFUWEftlbsNgEAMQ50T40SZiYKRkChYlM5UnNCBlDJXOAs4evLHIuIAsAFYUHQkd4sIFul3WZKXufvZWlvLiVTTePRNjwwERGS0hIiISFYT8sjHI1rfFxKt71+ClBo1q5o1IyCPZITm6RGN3qyjdwPPvC81yEz39gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHeader/menu.png
// module id = e1Aq
// module chunks = 0